import { type ParseResult } from "papaparse";
import { readCSV } from "./readCsvFile";
import { readExcel } from "./readExcelFile";

/**
 * ファイル名から拡張子を取得する
 * @param filename ファイル名
 * @return 拡張子（小文字）
 */
export const getFileExtension = (filename: string): string => {
  return filename.split(".").pop()?.toLowerCase() ?? "";
};

/**
 * ファイル形式に応じて適切な読み込み関数を呼び出す
 * @param file CSVまたはExcelファイル
 * @return パース結果オブジェクト
 */
export const readFile = async (file: File): Promise<ParseResult<unknown>> => {
  const extension = getFileExtension(file.name);

  if (extension === "csv") {
    return await readCSV(file);
  } else if (extension === "xlsx" || extension === "xls") {
    return await readExcel(file);
  } else {
    throw new Error("サポートされていないファイル形式です");
  }
};
